import AddIcon from "@mui/icons-material/Add";

import ModalMedia from "../../ModalMedia";
import GalleryLabeledActionButton from "../../../Gallery/GalleryLabeledActionButton";
import { isCompetitorMediaAllowedForReference } from "../utils";

const NOOP = () => {};

const ModalCompetitorsPreview = ({
  modalOpen = false,
  item = null,
  onCloseModal = NOOP,
  onGenerate = NOOP,
  isUploading = false,
  generateLabel,
  acceptedReferenceMediaType = null,
}) => {
  if (!item) return null;

  const showGenerateAction =
    Boolean(item.id) &&
    (!acceptedReferenceMediaType ||
      isCompetitorMediaAllowedForReference(
        item.type,
        acceptedReferenceMediaType
      ));

  const customActions = showGenerateAction ? (
    <GalleryLabeledActionButton
      variant="secondary"
      className="gallery-direct-add-button"
      label={generateLabel}
      icon={AddIcon}
      onClick={onGenerate}
      loading={isUploading}
      disabled={isUploading}
    />
  ) : null;

  return (
    <ModalMedia
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      url={item.url}
      item={item}
      showEditButton={false}
      showShareButton={false}
      showDeleteButton={false}
      showDownloadButton={false}
      disableRightClickSave
      customActions={customActions}
    />
  );
};

export default ModalCompetitorsPreview;
